import React from 'react';
import { ArrowRightIcon, SparklesIcon, RocketIcon, UsersIcon, GlobeIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const About = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white" data-id="element-366">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-indigo-50 to-white" data-id="element-367">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24" data-id="element-368">
          <div className="text-center" data-id="element-369">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-370">
              Transform Your AI Ideas into{' '}
              <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent" data-id="element-371">
                Reality
              </span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-372">
              RealUseAI is the leading platform for creating, sharing, and
              discovering practical AI applications. Turn your prompts into
              powerful tools that solve real problems.
            </p>
            <button onClick={() => navigate('/create')} className="bg-indigo-600 text-white px-8 py-3 rounded-lg text-lg font-medium hover:bg-indigo-700 transition-colors inline-flex items-center" data-id="element-373">
              Start Building <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-374" />
            </button>
          </div>
        </div>
      </div>
      {/* Stats Section */}
      <div className="bg-white py-16" data-id="element-375">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-376">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-377">
            <div className="text-center" data-id="element-378">
              <div className="text-3xl font-bold text-indigo-600 mb-2" data-id="element-379">
                100K+
              </div>
              <div className="text-gray-600" data-id="element-380">Active Users</div>
            </div>
            <div className="text-center" data-id="element-381">
              <div className="text-3xl font-bold text-indigo-600 mb-2" data-id="element-382">
                50K+
              </div>
              <div className="text-gray-600" data-id="element-383">AI Apps Created</div>
            </div>
            <div className="text-center" data-id="element-384">
              <div className="text-3xl font-bold text-indigo-600 mb-2" data-id="element-385">1M+</div>
              <div className="text-gray-600" data-id="element-386">Monthly Executions</div>
            </div>
            <div className="text-center" data-id="element-387">
              <div className="text-3xl font-bold text-indigo-600 mb-2" data-id="element-388">4.8</div>
              <div className="text-gray-600" data-id="element-389">Average Rating</div>
            </div>
          </div>
        </div>
      </div>
      {/* Features Section */}
      <div className="bg-gray-50 py-24" data-id="element-390">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-391">
          <h2 className="text-3xl font-bold text-center mb-16" data-id="element-392">
            Why Choose RealUseAI
          </h2>
          <div className="grid md:grid-cols-3 gap-12" data-id="element-393">
            <div className="text-center" data-id="element-394">
              <div className="bg-indigo-100 w-16 h-16 rounded-xl flex items-center justify-center mx-auto mb-6" data-id="element-395">
                <SparklesIcon className="h-8 w-8 text-indigo-600" data-id="element-396" />
              </div>
              <h3 className="text-xl font-semibold mb-4" data-id="element-397">Easy to Use</h3>
              <p className="text-gray-600" data-id="element-398">
                Create AI apps in minutes with our intuitive interface. No
                coding required.
              </p>
            </div>
            <div className="text-center" data-id="element-399">
              <div className="bg-indigo-100 w-16 h-16 rounded-xl flex items-center justify-center mx-auto mb-6" data-id="element-400">
                <RocketIcon className="h-8 w-8 text-indigo-600" data-id="element-401" />
              </div>
              <h3 className="text-xl font-semibold mb-4" data-id="element-402">Powerful Features</h3>
              <p className="text-gray-600" data-id="element-403">
                Access cutting-edge AI models and customize them to your needs.
              </p>
            </div>
            <div className="text-center" data-id="element-404">
              <div className="bg-indigo-100 w-16 h-16 rounded-xl flex items-center justify-center mx-auto mb-6" data-id="element-405">
                <GlobeIcon className="h-8 w-8 text-indigo-600" data-id="element-406" />
              </div>
              <h3 className="text-xl font-semibold mb-4" data-id="element-407">Global Community</h3>
              <p className="text-gray-600" data-id="element-408">
                Share your apps with millions of users or keep them private.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* How It Works */}
      <div className="bg-white py-24" data-id="element-409">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-410">
          <h2 className="text-3xl font-bold text-center mb-16" data-id="element-411">How It Works</h2>
          <div className="grid md:grid-cols-4 gap-8" data-id="element-412">
            <div className="text-center" data-id="element-413">
              <div className="text-2xl font-bold text-indigo-600 mb-4" data-id="element-414">1</div>
              <h3 className="font-semibold mb-2" data-id="element-415">Choose Your Template</h3>
              <p className="text-gray-600 text-sm" data-id="element-416">
                Start with a pre-built template or create from scratch
              </p>
            </div>
            <div className="text-center" data-id="element-417">
              <div className="text-2xl font-bold text-indigo-600 mb-4" data-id="element-418">2</div>
              <h3 className="font-semibold mb-2" data-id="element-419">Customize Your App</h3>
              <p className="text-gray-600 text-sm" data-id="element-420">
                Configure AI models and add your own prompts
              </p>
            </div>
            <div className="text-center" data-id="element-421">
              <div className="text-2xl font-bold text-indigo-600 mb-4" data-id="element-422">3</div>
              <h3 className="font-semibold mb-2" data-id="element-423">Test and Refine</h3>
              <p className="text-gray-600 text-sm" data-id="element-424">
                Preview your app and make it perfect
              </p>
            </div>
            <div className="text-center" data-id="element-425">
              <div className="text-2xl font-bold text-indigo-600 mb-4" data-id="element-426">4</div>
              <h3 className="font-semibold mb-2" data-id="element-427">Share with the World</h3>
              <p className="text-gray-600 text-sm" data-id="element-428">
                Publish your app to the marketplace
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* CTA Section */}
      <div className="bg-indigo-600 py-16" data-id="element-429">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-430">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-431">
            Ready to Start Building?
          </h2>
          <p className="text-indigo-100 mb-8 max-w-2xl mx-auto" data-id="element-432">
            Join thousands of creators who are building the future with AI.
          </p>
          <button onClick={() => navigate('/create')} className="bg-white text-indigo-600 px-8 py-3 rounded-lg text-lg font-medium hover:bg-indigo-50 transition-colors" data-id="element-433">
            Create Your First App
          </button>
        </div>
      </div>
    </div>;
};